import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { createCable as coreCreateCable, backoffWithJitter, DEFAULT_OPTIONS as DEFAULTS, ActionCableConsumer } from '@anycable/core';
import { Logger } from "./logger/index.js";
import { Monitor } from "./monitor/index.js";
export { Channel } from '@anycable/core';
var metaPrefixes = ['cable', 'action-cable'];
var defaultUrl = '/cable';
/* eslint-disable consistent-return */

var fetchMeta = function fetchMeta(doc, key) {
  var _iterator = _createForOfIteratorHelper(metaPrefixes),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var prefix = _step.value;
      var element = doc.head.querySelector("meta[name='".concat(prefix, "-").concat(key, "']"));

      if (element) {
        return element.getAttribute('content');
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
};

var absoluteWSUrl = function absoluteWSUrl(path) {
  if (path.match(/wss?:\/\//)) return path;

  if (typeof window !== 'undefined') {
    var proto = window.location.protocol.replace('http', 'ws');
    return "".concat(proto, "//").concat(window.location.host).concat(path);
  }

  return path;
};
/* eslint-disable consistent-return */


var generateUrlFromDOM = function generateUrlFromDOM() {
  if (typeof document !== 'undefined' && document.head) {
    var url = fetchMeta(document, 'url');

    if (url) {
      return absoluteWSUrl(url);
    }
  }

  return absoluteWSUrl(defaultUrl);
};

export function createCable(url, opts) {
  if (_typeof(url) === 'object' && typeof opts === 'undefined') {
    opts = url;
    url = undefined;
  }

  url = url || generateUrlFromDOM();
  opts = opts || {};
  opts = Object.assign({}, DEFAULTS, opts);
  var _opts = opts,
      logLevel = _opts.logLevel,
      logger = _opts.logger,
      pingInterval = _opts.pingInterval,
      reconnectStrategy = _opts.reconnectStrategy,
      maxMissingPings = _opts.maxMissingPings,
      maxReconnectAttempts = _opts.maxReconnectAttempts;
  logger = opts.logger = opts.logger || new Logger(logLevel);
  reconnectStrategy = opts.reconnectStrategy = opts.reconnectStrategy || backoffWithJitter(pingInterval);

  if (opts.monitor !== false) {
    opts.monitor = opts.monitor || new Monitor({
      pingInterval: pingInterval,
      reconnectStrategy: reconnectStrategy,
      maxMissingPings: maxMissingPings,
      maxReconnectAttempts: maxReconnectAttempts,
      logger: logger
    });
  }

  return coreCreateCable(url, opts);
}
export function createConsumer(url, opts) {
  var cable = createCable(url, opts);
  return new ActionCableConsumer(cable);
}
export function fetchTokenFromHTML(opts) {
  var url = opts ? opts.url : undefined;

  if (!url) {
    if (typeof window !== 'undefined') {
      url = window.location.href;
    } else {
      throw Error('An URL to fetch the HTML with a token MUST be specified');
    }
  }

  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(transport) {
      var response, html, doc, newURL;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return fetch(url, {
                credentials: 'same-origin',
                cache: 'no-cache',
                headers: {
                  'Accept': 'text/html, application/xhtml+xml',
                  'X-ANYCABLE-OPERATION': 'token-refresh'
                }
              });

            case 2:
              response = _context.sent;

              if (response.ok) {
                _context.next = 5;
                break;
              }

              throw Error('Failed to fetch a page to refresh a token: ' + response.status);

            case 5:
              _context.next = 7;
              return response.text();

            case 7:
              html = _context.sent;
              doc = new DOMParser().parseFromString(html, 'text/html');
              newURL = fetchMeta(doc, 'url');

              if (!newURL) {
                _context.next = 14;
                break;
              }

              transport.setURL(newURL);
              _context.next = 15;
              break;

            case 14:
              throw Error("Couldn't find a token on the page");

            case 15:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
}